import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

/**
 * FIXME: infer Generic from RadioOption in RadioGroup
 */
interface RadioGroupContextType {
  canUncheck: boolean;
  setCanUncheck: Dispatch<SetStateAction<boolean>>;
  value: string | null;
  setValue: Dispatch<SetStateAction<string | null>>;
  // function to notify external consumer (set by RadioGroup vm)
  emitChange?: (v: string | null) => void;
  setEmitChange: Dispatch<SetStateAction<((v: string | null) => void) | undefined>>;
}

const RadioGroupContext = createContext<RadioGroupContextType | undefined>(undefined);

export const useRadioGroupContext = () => {
  const context = useContext(RadioGroupContext);
  if (!context) {
    throw new Error('using useRadioGroupContext outside RadioGroupContextProvider not allowed');
  }
  return context;
};

const useRadioGroupContextProvider = () => {
  const [canUncheck, setCanUncheck] = useState(false);
  const [value, setValue] = useState<string | null>(null);
  const [emitChange, setEmitChange] = useState<((v: string | null) => void) | undefined>(undefined);

  return useMemo(
    () => ({
      canUncheck,
      setCanUncheck,
      value,
      setValue,
      emitChange,
      setEmitChange,
    }),
    [canUncheck, value, emitChange]
  );
};

interface RadioGroupContextProviderProps {
  children: ReactNode;
}

const RadioGroupContextProvider = ({ children }: RadioGroupContextProviderProps) => {
  const providerValue = useRadioGroupContextProvider();
  return <RadioGroupContext.Provider value={providerValue}>{children}</RadioGroupContext.Provider>;
};

export default RadioGroupContextProvider;
